module.exports = __webpack_public_path__ + "cancellara-dist/img/servizi_business_2.3f8f936f.png";